import { Injectable } from '@angular/core';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


@Injectable({
    providedIn: 'root'
})
export class ExcelExporterService {
    constructor() { }

    public async exportData(data: any[], fileName: string) {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Sheet1');

        // Define columns
        sheet.columns = Object.keys(data[0]).map(key => ({
            header: key,
            key: key,
            width: 20
        }));

        // Make header row bold
        const headerRow = sheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
        });
        
        // Add rows
        data.forEach(item => sheet.addRow(item));

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, `${fileName}.xlsx`);
    }
}

